<div class="modal-content">
  <!--Header-->
  <div
    class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0"
  >
    <div class="modal-title">
      <h4>Create and Email Form 3310</h4>
    </div>
    <button
      type="button"
      class="close-btn"
      style="margin-left: auto"
      (click)="closeModalClick()"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <!--Body-->
  <div class="modal-body pb-4">
    <div class="d-flex flex-column gap-3 mt-3">
      <div class="row align-items-center">
        <label
          for="local_authority"
          class="col-sm-5 col-form-label form-label text-end mb-0"
        >
          Local Authority to receive Form 3310:
        </label>
        <div class="col-sm-7 flex-grow-1">
          <input
            type="text"
            class="form-control modern-input text-uppercase"
            style="width: 100%"
            id="local_authority"
            [(ngModel)]="local_authority_name"
          />
        </div>
      </div>

      <div class="row align-items-center">
        <label
          for="local_authority_email"
          class="col-sm-5 col-form-label form-label text-end mb-0"
        >
          Local Authority Email:
        </label>
        <div class="col-sm-7 flex-grow-1">
          <input
            class="form-control modern-input"
            style="width: 100%"
            type="text"
            id="local_authority_email"
            [(ngModel)]="local_authority_email"
          />
        </div>
      </div>

      <div class="row align-items-center">
        <label
          for="atf_email"
          class="col-sm-5 col-form-label form-label text-end mb-0"
        >
          ATF Email:
        </label>
        <div class="col-sm-7 flex-grow-1">
          <input
            class="form-control modern-input"
            style="width: 100%"
            type="text"
            id="atf_email"
            [(ngModel)]="atf_email"
          />
        </div>
      </div>
    </div>

    <div class="d-flex flex-wrap justify-content-end gap-3 mt-4">
      <button
        type="button"
        class="btn modern-btn secondary-btn px-4"
        (click)="reviewForm3310()"
      >
        <i class="fa-solid fa-magnifying-glass me-2"></i>
        Review Form 3310
      </button>
      <button
        type="button"
        class="btn modern-btn primary-btn px-4"
        (click)="emailForm3310()"
      >
        <i class="fa-solid fa-envelope me-2"></i>
        Email Form
      </button>
    </div>
  </div>
</div>
